import classNames from 'classnames';
import React, { useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import Select from 'react-select';
import { CancelationReasonDTO } from '../../../../../common/types/dto/CancelationReasonDTO';
import cssForms from '../../../../assets/scss/Forms.scss';
import { RootState } from '../../../../base/RootReducer';
import { config } from '../../../../common/';
import Check from '../../DynamicTable/Check';
import css from './ModalShowDetails.scss';

export interface ModalShowDetailsState {
    reasonText: string;
    reasonCode: number;
}

export interface ModalShowDetailsProps {
    isOpen: boolean;
    header: string;
    title: string;
    disclaimer: string;
    items: string[];
    showReason: boolean;
    reasonTitle: string;
    onRequestClose(): void;
    onRequestConfirm(reasonCode: number, reasonText: string): void;
}

interface ReduxStateProps {
    cancelationReasons: CancelationReasonDTO[] | undefined;
}

type ModalShowDetailsProperties =
    ReduxStateProps
    & ModalShowDetailsProps;

function ModalShowDetails(props: ModalShowDetailsProperties) {
    const initialState: ModalShowDetailsState = {
        reasonText: '',
        reasonCode: 0,
    };
    const [state, setState]: [ModalShowDetailsState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );
    function onReasonChange(event: React.FormEvent<HTMLInputElement>) {
        setState({ reasonText: event.currentTarget.value });
    }
    const { t } = useTranslation();

    function onReasonCodeChange(selected: any) {
        if (props.cancelationReasons && selected) {
            setState({
                reasonCode: selected.value,
            });
        }
    }

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onRequestClose}
            contentLabel="Modal"
            className={{
                base: `${css.modalbase}`,
                afterOpen: `${css.modalbase_afteropen}`,
                beforeClose: `${css.modalbase_beforeclose}`,
            }}
            overlayClassName={{
                base: `${css.overlaybase}`,
                afterOpen: `${css.overlaybase_afteropen}`,
                beforeClose: `${css.overlaybase_beforeclose}`,
            }}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={500}
        >
            <div className={css.modalInternal}>
                <div className={css.titleModal}>
                    <h1>{props.header}</h1>
                    <button onClick={props.onRequestClose}>X</button>
                </div>
                <h4 className={css.subText}>{props.title}</h4>
                <div>
                    {props.items.map((item: string, idx: any) => {
                        return (
                            <div className={css.marginDivs} key={`modalitem${idx}`}>
                                <Check width={18} fill={'#195ece'} />
                                <text>{item}</text>
                            </div>
                        );
                    })}
                </div>
                {props.disclaimer && <React.Fragment>
                    <br />
                    <h4>{props.disclaimer}</h4>
                </React.Fragment>}

                {props.showReason && <React.Fragment>
                    <br />
                    <h4 className={css.subText}>{props.reasonTitle}</h4>
                    <Select placeholder={t('subscriptions:selectAnOption')} options={props.cancelationReasons} onChange={onReasonCodeChange} noOptionsMessage={() => t('subscriptions:noResults')} />
                    {config.SubscCancelReasonOther === state.reasonCode && <div className={[cssForms.input, cssForms.required, cssForms.padDesktop].join(' ')}>
                        <br />
                        <label>
                            <span>{t('subscriptions:reasonHeader')}</span>
                            <input value={state.reasonText} onChange={onReasonChange} />
                        </label>
                    </div>}
                </React.Fragment>}

                <button className={css.buttonInternal} onClick={() => props.onRequestConfirm(state.reasonCode, state.reasonText)}>Confirmar</button>
                <button className={classNames([css.buttonInternal, css.buttonWhite])} onClick={props.onRequestClose}>Fechar</button>
            </div>
        </Modal>
    );
}

const mapStateToProps = (store: RootState) => ({
    cancelationReasons: store.appState.lookupValues.cancelationReasons,
});

export default connect(mapStateToProps)(ModalShowDetails);
